import { useTranslation } from 'react-i18next';

const SCHEDULE_COUNT = 5;
const scheduleIndices = Array.from({ length: SCHEDULE_COUNT }, (_, i) => i);

function renderParagraphs(value: string, className: string) {
  return (
    <>
      {value.split(/\n{2,}/).map((paragraph, index) => (
        <p key={index} className={className}>
          {paragraph}
        </p>
      ))}
    </>
  );
}

export default function DailySchedule() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-100">
      <div className="max-w-[800px] mx-auto px-8">
        <div className="text-center mb-16">
          {renderParagraphs(
            t('coursesMaster.schedule.label'),
            'text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label'
          )}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-4">
            {t('coursesMaster.schedule.title')}
          </h2>
          <div className="gold-line mx-auto mb-4"></div>
          {renderParagraphs(
            t('coursesMaster.schedule.lead'),
            'text-[16px] text-foreground-600 tracking-[0.04em] max-w-xl mx-auto leading-relaxed'
          )}
        </div>
        <div className="relative">
          <div className="absolute left-[19px] top-0 bottom-0 w-[1px] bg-gradient-to-b from-accent-500/40 via-accent-500/20 to-accent-500/40 hidden sm:block"></div>
          <div className="space-y-0">
            {scheduleIndices.map((index) => {
              const description = t(`coursesMaster.schedule.${index}.description`);
              return (
                <div key={index} className="flex gap-6 pb-10 last:pb-0">
                  <div className="hidden sm:flex flex-col items-center flex-shrink-0 relative z-10">
                    <div className="w-[39px] h-[39px] rounded-full border border-accent-500/40 bg-background-100 flex items-center justify-center">
                      <span className="w-2 h-2 rounded-full bg-accent-500/60"></span>
                    </div>
                  </div>
                  <div className="flex-1 pt-1">
                    <div className="flex flex-col sm:flex-row sm:items-baseline gap-2 sm:gap-4 mb-3">
                      <span className="text-[14px] text-accent-600 tracking-[0.08em] font-medium whitespace-nowrap font-label">
                        {t(`coursesMaster.schedule.${index}.time`)}
                      </span>
                      <h4 className="font-heading text-[17px] text-foreground-900 tracking-[0.06em]">
                        {t(`coursesMaster.schedule.${index}.title`)}
                      </h4>
                    </div>
                    {description &&
                      renderParagraphs(
                        description,
                        'text-[15px] text-foreground-600 leading-relaxed tracking-[0.03em]'
                      )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        {renderParagraphs(
          t('coursesMaster.schedule.note'),
          'text-[13px] text-foreground-500 tracking-[0.04em] mt-8 text-center'
        )}
      </div>
    </section>
  );
}
